import { ItemEntity } from '@entities/Item/Types';

export const IsItemSelected = (uuid: string, selectedItems: ItemEntity[]) => {
    const selectedItemUuids = selectedItems.map(item => item.uuid);
    return selectedItemUuids.includes(uuid);
};
